import { render } from "./DCalendarSettings.vue?vue&type=template&id=4e1c19b2"
import script from "./DCalendarSettings.vue?vue&type=script&lang=js"
export * from "./DCalendarSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__